function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { SafeAreaView } from 'react-native';
import { NativeBaseProvider, View, Spinner, extendTheme } from 'native-base';
import { colors, fontSizes, breakpoints } from '../../theme';
import RichTextBox from '../content/common/reusables/RichTextBox';
import { useCategoriesState } from '../../context/categories';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { messageBusUtil, useMessageBusDispatch } from '../../context/messagebus';
import { usePostManager } from '../hooks/usePostManager';
const theme = extendTheme({
  colors,
  fontSizes,
  breakpoints
});
const PostPresentation = props => {
  var _categoriesState$foru;
  const authState = useAuthState();
  const envState = useEnvState();
  const messageBusDispatch = useMessageBusDispatch();
  const {
    handlePost
  } = usePostManager();
  const categoriesState = useCategoriesState();
  const selectedPostCategoryId = (categoriesState === null || categoriesState === void 0 || (_categoriesState$foru = categoriesState.forumCategories) === null || _categoriesState$foru === void 0 || (_categoriesState$foru = _categoriesState$foru.find(c => c.name === props.selectedCategory)) === null || _categoriesState$foru === void 0 ? void 0 : _categoriesState$foru.id) ?? undefined;
  const handlePostWrapper = async data => {
    const postResponse = await handlePost({
      data,
      messageBusUtil,
      messageBusDispatch,
      trackForum: props.trackForum
    });
    return props.postCallback ? props.postCallback(postResponse) : postResponse;
  };
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(SafeAreaView, null, !props.userAuthenticated ? /*#__PURE__*/React.createElement(View, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Spinner, null)) : /*#__PURE__*/React.createElement(RichTextBox, _extends({}, props, {
    id: "newTopic",
    key: "newTopic",
    selectedPostCategoryId: selectedPostCategoryId,
    handlePost: handlePostWrapper,
    changeCategoriesAllowed: true
  }))));
};
export default PostPresentation;
//# sourceMappingURL=PostPresentation.js.map